export const profileItems = [
  { label: "profile.companyName", key: "companyName" },
  { label: "profile.businessLicenseNumber", key: "licenseNumber4Digit" },
  { label: "profile.industry", key: "industry" },
  { label: "profile.YearOfEstablishment", key: "yearEstablished" },
  { label: "profile.bankInfo", key: "bankInfo4Digit" },
];
